module.exports = "varying vec2 f_uv;\r\nvarying vec3 pos;\r\n\r\nvoid main() {\r\n    f_uv = uv;\r\n    pos = position;\r\n\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/point-vert.glsl
// module id = 38
// module chunks = 0